/**
 * adminWorkspaceContext.ts
 * 官方工作台上下文 —— 用于标识当前是否处于官方工作台模式
 * 在官方工作台模式下，通讯录和办公室会注入37名系统数字员工
 */

/** 判断当前 URL 是否在工作台路径下（不依赖组件渲染时序，始终准确） */
function isWorkspacePath(): boolean {
  try {
    return window.location.pathname.startsWith('/admin-workspace') &&
      !window.location.pathname.startsWith('/admin-workspace/login');
  } catch {
    return false;
  }
}

let _isAdminWorkspace = isWorkspacePath();
const _listeners = new Set<(val: boolean) => void>();

export function setAdminWorkspaceMode(val: boolean) {
  if (_isAdminWorkspace === val) return;
  _isAdminWorkspace = val;
  _listeners.forEach(fn => fn(val));
}

export function isAdminWorkspaceMode(): boolean {
  // 双重保险：state 为 true 或当前路径是工作台路径，都认为是工作台模式
  return _isAdminWorkspace || isWorkspacePath();
}

export function subscribeAdminWorkspaceMode(fn: (val: boolean) => void): () => void {
  _listeners.add(fn);
  return () => _listeners.delete(fn);
}

// 官方工作台功能面板触发器（由 page.tsx 注入，HomePage 调用）
type WorkspacePanelTriggers = {
  openDashboard: () => void;
  openBroadcast: () => void;
  openAuditLog: () => void;
  openDataScreen: () => void;
  openOpsLab: () => void;
  openSalesPerf?: () => void;
};

let _triggers: WorkspacePanelTriggers | null = null;

export function registerWorkspacePanelTriggers(triggers: WorkspacePanelTriggers) {
  _triggers = triggers;
}

export function getWorkspacePanelTriggers(): WorkspacePanelTriggers | null {
  return _triggers;
}
